import './GerarRelatorios.css'
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../authContext';
import AlertsCustom from '../../../components/Alerts/index';

function GerarRelatorios({classeCSS, setSessions, sessions, setSelectedSession, setChatHistory, setLoading, model, setMessages, sessionId, setSessionId, totalCost, setTotalCost, user, assistant, assistantId}){

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const { t: tChat } = useTranslation('chat');
    const { t: tCommon } = useTranslation('common');
    const {newSessionId} = useContext(AuthContext);
    const {accessToken, setAccessToken} = useContext(AuthContext);
    const [alertTitle, setAlertTitle] = useState("");
    const [alertType, setAlertType] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);

    const handleGenerateReport = async () => {
        if (!startDate || !endDate) {
            //alert("Por favor, selecione ambas as datas.");
            setAlertTitle("Erro");
            setAlertType("error")
            setAlertMessage(tChat('erro_data_site'))
            setShowAlert(true);
            return;
        }

        let generatedSessionId = sessionId;
        
        try {
            // Chama a função para gerar o novo session_id e armazena o retorno
            generatedSessionId = newSessionId();

            // Define o histórico inicial no formato esperado
            const history = [
                { role: "system", content: "" },
                { role: "assistant", content: "New session started. How can I assist you?" }
            ];
            // Atualiza as sessões e o histórico
            setSessions([generatedSessionId, ...sessions]); // Adiciona o novo session_id à lista
            setSelectedSession(generatedSessionId); // Define a nova sessão como selecionada
            if (typeof setSessionId === 'function') {
                setSessionId(generatedSessionId);
            }
            setChatHistory(history); // Atualiza o histórico do chat no componente pai

        } catch (error) {
            console.error('Erro ao criar nova sessão:', error);
        }
 
        try {
            setLoading(true)
            const response = await fetch(`${process.env.REACT_APP_API_URL}/post_process_report`, {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json", 
                    "Authorization": `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    report_start_date: startDate,
                    report_end_date: endDate,
                    llm: model,
                    'session_id': generatedSessionId,
                    'email': user,
                    'total_cost': totalCost,
                    'assistant': assistant
                }),
            });
            const data = await response.json();
            const custo = Number(data.total_cost);
            setTotalCost(Number.isFinite(custo) ? custo : 0);
            setLoading(false)
            setMessages([{ role: 'assistant', content: data.report }]);  // Define apenas a mensagem do relatório
        } catch (error) {
            console.error('Erro ao gerar relatório:', error);
        }
    };

    return(
        <div className={classeCSS}>
            <div className='header-gerador'>
                <img src="/imagens/lupa.svg" alt={tChat('searchIcon')} className="lupa-icon" />
                <strong>{tChat('reports')}</strong>
            </div>
            
            <div className='linha-azul'></div>

            <div className='datas'>
                
                <div className='seleciona-data'>
                    <span><strong>{tCommon('start')}</strong></span>
                    <input
                        type="date"
                        value={startDate}
                        className='no-calendar'
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </div>
                
                <div className='seleciona-data'>
                    <span><strong>{tCommon('end')}</strong></span>
                    <input
                    type="date"
                    className='no-calendar'
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
            </div>

            <div className='conteiner-gerador'>
                {showAlert && (
                    <AlertsCustom
                        type={alertType}
                        title={alertTitle}
                        message={alertMessage}
                        onClose={() => setShowAlert(false)}
                    />
                )}
                <button onClick={handleGenerateReport}>{tCommon('generate')}</button>
            </div>

        </div>
    );
}

export default GerarRelatorios;